import {
  type Control,
  Controller,
  type FieldValues,
  type Path,
} from "react-hook-form";

import { FieldError, Input, Label, TextField } from "@/components/field";

type BasicInformationProps<T extends FieldValues> = {
  control: Control<T>;
  emailField: Path<T>;
  nameField: Path<T>;
};

export function BasicInformation<T extends FieldValues>({
  control,
  emailField,
  nameField,
}: BasicInformationProps<T>) {
  return (
    <div>
      <div className="flex flex-col gap-y-lg mt-3 lg:grid lg:grid-cols-2 lg:gap-x-3xl">
        <Controller
          control={control}
          name={nameField}
          render={({
            field: { name, onBlur, onChange, ref, value },
            fieldState: { error, invalid },
          }) => (
            <TextField
              isInvalid={invalid}
              name={name}
              onBlur={onBlur}
              onChange={onChange}
              validationBehavior="aria"
              value={value}
            >
              <Label requiredHint>Name</Label>
              <Input placeholder="Name" ref={ref} />
              <FieldError>{error?.message}</FieldError>
            </TextField>
          )}
        />
        <Controller
          control={control}
          name={emailField}
          render={({
            field: { name, onBlur, onChange, ref, value },
            fieldState: { error, invalid },
          }) => (
            <TextField
              isInvalid={invalid}
              name={name}
              onBlur={onBlur}
              onChange={onChange}
              validationBehavior="aria"
              value={value}
            >
              <Label requiredHint>Email</Label>
              <Input placeholder="email" ref={ref} />
              <FieldError>{error?.message}</FieldError>
            </TextField>
          )}
        />
      </div>
    </div>
  );
}
